import styled from 'styled-components';
import { mediaBreakpointMixin } from '@zillow/constellation';

export const ZillowNavbarNav = styled.nav`
    height: 100%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    @media ${mediaBreakpointMixin('sm_lte')} {
        z-index: 2;
    }
`;
